import translate from '@translate';
import React, { FC, useEffect } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import Select from 'src/components/Select';
import TextField from 'src/components/TextField';
import { TransportType } from 'src/types/transport';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import { Typography } from '@mui/material';
import { isDefined } from 'src/utils/isDefined';
import { PaidActionOptionType } from 'src/components/PaymentEdit';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

const arrKeys = ['COD_PRICE', 'COD_CURRENCY', 'COD_REF_NUMBER'];

export interface PaidConfirmDataType {
    data: TransportType;
    errors: FormErrorsType;
    disabled?: boolean;
}
export interface PaidConfirmPropsType {
    setData: (data: PaidConfirmDataType) => void;
    data: PaidConfirmDataType;
    paidOption: PaidActionOptionType;
    currencyCodes: ConstantsCodeType[];
}

const PaidConfirm: FC<PaidConfirmPropsType> = (props) => {
    useEffect(() => {
        if (props.paidOption.label === 'cashOnDelivery') {
            props.setData({ data: {}, errors: {}, disabled: true });
        }
    }, []);

    if (props.paidOption.label !== 'cashOnDelivery') {
        return (
            <>
                <Typography>{translate('transportDetail.confirmPaidActionText')}</Typography>
                <Typography>{translate('transportDetail.confirmPaidActionText2')}</Typography>
            </>
        );
    }

    const { data, errors } = props.data;

    const onChange: OnChangeType<EditKeysType> = (key, value, error) => {
        const newData = { ...data };
        const newErrors = { ...errors };
        if (error) {
            newErrors[key] = true;
        } else {
            delete newErrors[key];
        }

        newData[key] = value;
        const newDisabled =
            arrKeys.filter((checkKey: any): any => !isDefined(newData[checkKey]) || newErrors[checkKey]).length > 0;
        props.setData({ data: newData, errors: newErrors, disabled: newDisabled });
    };

    return (
        <Grid>
            <GridItem cols={12}>
                <Typography variant="h3">{translate('transportDetail.confirmPaidActionText')}</Typography>
                <Typography variant="h3" gutterBottom>
                    {translate('transportDetail.confirmPaidActionTextCOD')}
                </Typography>
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={data?.COD_PRICE}
                    error={errors?.COD_PRICE}
                    onChange={(value, error) => onChange('COD_PRICE', value, error)}
                    name="COD_PRICE"
                    label={translate('transportDetail.cashOnDeliveryPrice')}
                    fullWidth
                    required
                    min={0}
                    type="numberLocale"
                />
            </GridItem>
            <GridItem cols={12}>
                <Select
                    options={props.currencyCodes}
                    value={data?.COD_CURRENCY}
                    error={errors?.COD_CURRENCY}
                    onChange={(value, error) => onChange('COD_CURRENCY', value, error)}
                    name="COD_CURRENCY"
                    label={translate('transportDetail.cashOnDeliveryCurrency')}
                    fullWidth
                    required
                />
            </GridItem>
            <GridItem cols={12}>
                <TextField
                    value={data?.COD_REF_NUMBER}
                    error={errors?.COD_REF_NUMBER}
                    onChange={(value, error) => onChange('COD_REF_NUMBER', value, error)}
                    name="COD_REF_NUMBER"
                    label={translate('transportDetail.cashOnDeliveryRefNumber')}
                    fullWidth
                    required
                />
            </GridItem>
        </Grid>
    );
};

export default PaidConfirm;
